var _rect, _g, _rect2, _g2, _rect3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "editor-view__logo-preview",
    "data-v-04588dbe": "",
    "data-v-0a059b40": "",
    width: 258.3666687011719,
    height: 54,
    viewBox: "0 0 258.3666687011719 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "mark",
    viewBox: "0 0 32 32",
    width: 54,
    height: 54,
    style: {
      fill: "rgb(120, 220, 230)"
    },
    x: 0,
    y: 0,
    "data-v-04588dbe": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "none",
    "data-v-04588dbe": ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-04588dbe": ""
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "9.382,8.675 23.325,8.675 23.325,22.618 32,31.293 32,0 0.707,0   "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.618,23.325 8.675,23.325 8.675,9.382 0,0.707 0,32 31.293,32   "
  })))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "name",
    viewBox: "0 0 188.357421875 34.94921875",
    width: 188.357421875,
    height: 34.94921875,
    style: {
      fill: "rgb(245, 238, 238)"
    },
    x: 70,
    y: 9.525001525878906,
    "data-v-04588dbe": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "none",
    "data-v-04588dbe": ""
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-v-04588dbe": ""
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M19.92 23.61L26.66 23.61Q26.28 28.88 22.76 31.92Q19.25 34.95 13.50 34.95L13.50 34.95Q7.21 34.95 3.60 30.72Q0 26.48 0 19.09L0 19.09L0 17.09Q0 12.38 1.66 8.78Q3.32 5.19 6.41 3.27Q9.50 1.35 13.59 1.35L13.59 1.35Q19.25 1.35 22.71 4.38Q26.17 7.41 26.71 12.89L26.71 12.89L19.97 12.89Q19.72 9.73 18.20 8.30Q16.69 6.87 13.59 6.87L13.59 6.87Q10.22 6.87 8.55 9.29Q6.87 11.70 6.83 16.78L6.83 16.78L6.83 19.25Q6.83 24.55 8.43 27.00Q10.04 29.45 13.50 29.45L13.50 29.45Q16.62 29.45 18.16 28.02Q19.70 26.59 19.92 23.61L19.92 23.61ZM51.30 34.50L44.74 34.50Q44.29 33.62 44.09 32.32L44.09 32.32Q41.73 34.95 37.96 34.95L37.96 34.95Q34.39 34.95 32.04 32.88Q29.69 30.82 29.69 27.67L29.69 27.67Q29.69 23.81 32.56 21.74Q35.42 19.68 40.83 19.65L40.83 19.65L43.82 19.65L43.82 18.26Q43.82 16.58 42.96 15.57Q42.09 14.55 40.23 14.55L40.23 14.55Q38.59 14.55 37.66 15.34Q36.72 16.13 36.72 17.50L36.72 17.50L30.23 17.50Q30.23 15.39 31.54 13.59Q32.84 11.79 35.22 10.77Q37.60 9.75 40.56 9.75L40.56 9.75Q45.06 9.75 47.70 12.01Q50.33 14.26 50.33 18.35L50.33 18.35L50.33 28.88Q50.36 32.34 51.30 34.12L51.30 34.12L51.30 34.50ZM39.37 29.99L39.37 29.99Q40.81 29.99 42.02 29.35Q43.24 28.71 43.82 27.63L43.82 27.63L43.82 23.45L41.40 23.45Q36.52 23.45 36.21 26.82L36.21 26.82L36.18 27.20Q36.18 28.41 37.04 29.20Q37.89 29.99 39.37 29.99ZM70.39 34.50L64.15 24.75L61.81 27.09L61.81 34.50L55.32 34.50L55.32 0L61.81 0L61.81 19.11L63.07 17.50L69.29 10.20L77.09 10.20L68.30 20.33L77.85 34.50L70.39 34.50ZM86.74 10.20L86.74 34.50L80.23 34.50L80.23 10.20L86.74 10.20ZM79.85 3.91L79.85 3.91Q79.85 2.45 80.83 1.50Q81.80 0.56 83.49 0.56L83.49 0.56Q85.15 0.56 86.14 1.50Q87.13 2.45 87.13 3.91L87.13 3.91Q87.13 5.39 86.13 6.33Q85.13 7.28 83.49 7.28Q81.85 7.28 80.85 6.33Q79.85 5.39 79.85 3.91ZM91.96 10.20L98.06 10.20L98.27 13.00Q100.87 9.75 105.25 9.75L105.25 9.75Q109.12 9.75 111.00 12.02Q112.89 14.29 112.93 18.80L112.93 18.80L112.93 34.50L106.44 34.50L106.44 18.96Q106.44 16.89 105.54 15.96Q104.65 15.03 102.56 15.03L102.56 15.03Q99.82 15.03 98.45 17.36L98.45 17.36L98.45 34.50L91.96 34.50L91.96 10.20ZM131.01 27.78L131.01 27.78Q131.01 26.59 129.84 25.91Q128.66 25.22 126.05 24.68L126.05 24.68Q117.38 22.87 117.38 17.32L117.38 17.32Q117.38 14.08 120.06 11.92Q122.75 9.75 127.08 9.75L127.08 9.75Q131.71 9.75 134.48 11.93Q137.26 14.11 137.26 17.59L137.26 17.59L130.77 17.59Q130.77 16.19 129.87 15.28Q128.97 14.38 127.06 14.38L127.06 14.38Q125.42 14.38 124.52 15.12Q123.63 15.86 123.63 17.00L123.63 17.00Q123.63 18.08 124.65 18.74Q125.67 19.41 128.09 19.89Q130.52 20.37 132.18 20.98L132.18 20.98Q137.33 22.87 137.33 27.51L137.33 27.51Q137.33 30.84 134.47 32.89Q131.62 34.95 127.11 34.95L127.11 34.95Q124.05 34.95 121.68 33.86Q119.31 32.77 117.96 30.87Q116.62 28.97 116.62 26.77L116.62 26.77L122.77 26.77Q122.86 28.50 124.05 29.42Q125.24 30.34 127.24 30.34L127.24 30.34Q129.11 30.34 130.06 29.64Q131.01 28.93 131.01 27.78ZM140.49 22.42L140.49 22.12Q140.49 18.51 141.89 15.68Q143.28 12.85 145.90 11.30Q148.51 9.75 151.97 9.75L151.97 9.75Q156.89 9.75 160.00 12.76Q163.11 15.77 163.47 20.93L163.47 20.93L163.52 22.60Q163.52 28.19 160.39 31.57Q157.27 34.95 152.02 34.95Q146.76 34.95 143.63 31.58Q140.49 28.21 140.49 22.42L140.49 22.42ZM146.98 22.60L146.98 22.60Q146.98 26.05 148.29 27.89Q149.59 29.72 152.02 29.72L152.02 29.72Q154.37 29.72 155.70 27.91Q157.02 26.10 157.02 22.12L157.02 22.12Q157.02 18.73 155.70 16.87Q154.37 15.00 151.97 15.00L151.97 15.00Q149.59 15.00 148.29 16.86Q146.98 18.71 146.98 22.60ZM167.38 10.20L173.49 10.20L173.69 13.00Q176.30 9.75 180.68 9.75L180.68 9.75Q184.54 9.75 186.43 12.02Q188.31 14.29 188.36 18.80L188.36 18.80L188.36 34.50L181.87 34.50L181.87 18.96Q181.87 16.89 180.97 15.96Q180.07 15.03 177.98 15.03L177.98 15.03Q175.24 15.03 173.87 17.36L173.87 17.36L173.87 34.50L167.38 34.50L167.38 10.20Z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "slogan",
    viewBox: "0 0 0 0",
    width: 0,
    height: "NaN",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    x: 70,
    y: 48.474998474121094,
    "data-v-04588dbe": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "none",
    "data-v-04588dbe": ""
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-v-04588dbe": ""
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e4ad7ab27dad1e9414e103f0ea845e04.svg";
export { ForwardRef as ReactComponent };